const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaCidade: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'TIPO_PRODUCAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'TIPO_PRODUCAO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'TIPO_PRODUCAO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };

        case 'TIPO_PRODUCAO_CIDADE_LISTADO':            
			return { ...state, listaCidade: action.payload.data };

        default:
            return state;
    }
}
